class Internship {
  constructor(root) {
    this.root = root;

    this.voiceSwiperEl = this.root.querySelector(".js-voice-swiper");

    this.init();
    this.mount();
  }
  init() {
    this.voiceSwiperEl && this.voiceSwiper();
  }
  mount() {}
  voiceSwiper() {
    const prevEl = this.root.querySelector(".js-voice-swiper__prev");
    const nextEl = this.root.querySelector(".js-voice-swiper__next");
    new Swiper(this.voiceSwiperEl, {
      loop: false,
      slidesPerView: "auto",
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
    });
  }
}
